import { combineReducers } from '@reduxjs/toolkit';

import getSalesSummary from './get_sales_summary';
import getSalesTimeSeries from './get_sales_time_series';
import getSalesByPod from './get_sales_by_pod';
import getTopProducts from './get_top_products';
import getSalesByCategory from './get_sales_by_category';

export default combineReducers({
    getSalesSummary,
    getSalesTimeSeries,
    getSalesByPod,
    getTopProducts,
    getSalesByCategory
});
